export const posts = [
  {
    id: 1,
    title: "Wie beantrage ich ein Visum für Madagaskar?",
    href: "#",
    description:
      "Unsere Anleitung zeigt dir, wie du ein Visum für Madagaskar beantragen kannst. Unsere Reise steht für den April 2024 an, und ich habe mich vorab um mein Visum gekümmert. Hier erfährst du, wie ich vorgegangen bin und was du beachten solltest. Madagaskar, mit seiner atemberaubenden Naturvielfalt und einzigartigen Tierwelt, lockt jährlich Tausende von Besuchern an. Doch bevor du die Schönheit dieser Insel erkunden kannst, ist es wichtig, dass du die notwendigen Schritte unternimmst, um dein Visum zu erhalten.\n\n1. Recherche über Visabestimmungen: Bevor du mit dem Antragsprozess beginnst, ist es entscheidend, dass du die aktuellen Visabestimmungen für Madagaskar recherchierst. Diese können sich je nach Staatsangehörigkeit und Reisezweck unterscheiden.\n2. Beantragung des Visums: In der Regel kannst du das Visum für Madagaskar entweder persönlich bei der Botschaft oder dem Konsulat des Landes beantragen, oder du nutzt die Möglichkeit der Online-Beantragung, falls verfügbar. Stelle sicher, dass du alle erforderlichen Unterlagen gemäß den Anweisungen des zuständigen Konsulats oder der Botschaft vorbereitest.\n3. Erforderliche Unterlagen: Zu den häufig benötigten Unterlagen gehören ein gültiger Reisepass, ein ausgefüllter Antragsformular, Passfotos, ein Rückflugticket und gegebenenfalls ein Nachweis über ausreichende finanzielle Mittel für deinen Aufenthalt.\n4. Bearbeitungszeit und Gebühren: Berücksichtige die Bearbeitungszeit für dein Visum und zahle die entsprechenden Gebühren rechtzeitig. Es ist ratsam, diesen Prozess frühzeitig zu beginnen, um Verzögerungen zu vermeiden.\n5. Verlängerungsmöglichkeiten: Informiere dich im Voraus über die Verlängerungsmöglichkeiten deines Visums, falls du länger als die ursprünglich genehmigte Aufenthaltsdauer bleiben möchtest. Madagaskar ist ein faszinierendes Reiseziel, das mit seiner einzigartigen Kultur, Landschaft und Tierwelt begeistert. Indem du rechtzeitig und sorgfältig dein Visum beantragst, kannst du sicherstellen, dass deine Reise reibungslos verläuft und du jeden Moment auf dieser zauberhaften Insel genießen kannst. Bereit, dein Abenteuer zu beginnen? Folge diesen Schritten, um dein Visum für Madagaskar zu beantragen, und bereite dich darauf vor, unvergessliche Erlebnisse zu sammeln!",
    date: "30. März 2024",
    datetime: "2024-03-30",
    category: {
      title: "Visum",
      href: "#",
    },
    author: {
      name: "Nico Wickersheim",
      role: "Seiteninhaber",
      href: "#",
      imageUrl: "https://avatars.githubusercontent.com/u/35769900?v=4",
    },
  },
  {
    id: 2,
    title: "Der erste Blogpost",
    href: "#",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "23. Januar 2024",
    datetime: "2024-01-23",
    category: { title: "Madagassisch", href: "#" },
    author: {
      name: "Nico Wickersheim",
      role: "Seiteninhaber",
      href: "#",
      imageUrl: "https://avatars.githubusercontent.com/u/35769900?v=4",
    },
  },
  {
    id: 3,
    title: "Der erste Blogpost",
    href: "#",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "23. Januar 2024",
    datetime: "2024-01-23",
    category: { title: "Madagassisch", href: "#" },
    author: {
      name: "Nico Wickersheim",
      role: "Seiteninhaber",
      href: "#",
      imageUrl: "https://avatars.githubusercontent.com/u/35769900?v=4",
    },
  },
  {
    id: 4,
    title: "Der erste Blogpost",
    href: "#",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "23. Januar 2024",
    datetime: "2024-01-23",
    category: { title: "Madagassisch", href: "#" },
    author: {
      name: "Nico Wickersheim",
      role: "Seiteninhaber",
      href: "#",
      imageUrl: "https://avatars.githubusercontent.com/u/35769900?v=4",
    },
  },
];
